import { Link, useNavigate } from 'react-router-dom'
import { useCreateBilancia } from '../../hooks/bilance'
import { Button, Card, CardBody } from 'react-bootstrap'
import { Bilancia } from '../../types'

import * as yup from 'yup'
import FormBilancia from '../Bilance/FormBilancia'
import { Formik, FormikHelpers } from 'formik'
import { PartialWithId } from '@inmagik/react-crud/dist/types'
import { useCallback, useEffect, useState } from 'react'
import { useQsFilters } from '../../hooks/filters'
import { API_URL } from '../../constants'
import { fetchApiJson } from '@inmagik/react-crud'
import { useAuth } from '../../auth'

const initialValues = {
  matricola: '',
  tipo_bilancia: '',
  tipo_bilancia_em: '',
  nome_produttore: '',
  sede: undefined,
  verif_periodica: '',
  cert_approv: '',
}

const schema = yup.object().shape({
  matricola: yup.string().required().label('Matricola'),
  tipo_bilancia: yup.string().required().label('Tipo bilancia'),
  tipo_bilancia_em: yup.string().required().label('Tipo bilancia'),
  nome_produttore: yup.string().required().label('Nome produttore'),
  sede: yup.number().required().label('Sede'),
  verif_periodica: yup.boolean().required().label('Strumento omologato'),
  cert_approv: yup
    .string()
    .label('Provvedimento')
    .when('verif_periodica', (verif_periodica: any, schema: any) => {
      if (verif_periodica[0] !== 'false' && verif_periodica[0] !== false) {
        return schema.required()
      } else {
        return schema.notRequired()
      }
    }),
  anno_marcatura_ce: yup
    .string()
    .nullable()
    .matches(/^[0-9]{4}$/, 'Deve essere un anno a 4 cifre')
    .label('Anno marcatura CE'),
})

const initFilters = (params: URLSearchParams) => ({
  duplicate_from: params.get('duplicate_from') ?? '',
})

export default function BilanciaCrea() {
  const { mutateAsync: createBilancia, status: createBilanciaStatus } =
    useCreateBilancia()

  const navigate = useNavigate()

  const saveBilancia = useCallback(
    (bilancia: PartialWithId<Bilancia>, actions: FormikHelpers<Bilancia>) => {
      return createBilancia({
        ...bilancia,
        sede: bilancia?.sede,
      }).then((bilancia) => {
        navigate(`/bilance/${bilancia.id}`)
        actions.resetForm()
      })
    },
    [createBilancia]
  )

  // check if we are creating a new bilancia from an existing one from query params duplicate_from
  const { filters } = useQsFilters(initFilters)

  const { tokens } = useAuth()

  const [bilanciaDuplicate, setBilanciaDuplicate] = useState<Bilancia | null>(
    null
  )

  useEffect(() => {
    if (filters.duplicate_from) {
      // fetch bilancia and set as initialValues
      fetchApiJson(`${API_URL}/bilance/bilancia/${filters.duplicate_from}`, {
        headers: {
          Authorization: `Bearer ${tokens?.access}`,
        },
      }).then((bilancia: Bilancia) => {
        // delete modello_e from bilancia
        const {
          doc_modello_e,
          doc_anagrafica_pesa,
          doc_comunicaz_installaz,
          doc_dichiaraz_ue_om,
          doc_anagrafica_pesa_data_generazione,
          doc_anagrafica_pesa_generato,
          doc_comunicaz_installaz_data_generazione,
          doc_comunicaz_installaz_generato,
          doc_dichiaraz_ue_om_data_generazione,
          doc_dichiaraz_ue_om_generato,
          doc_modello_e_data_generazione,
          doc_modello_e_generato,
          collaudo_xlsm,
          foto_targa,
          data_intervento_periodica,
          data_intervento_periodica_aperto,
          data_intervento_taratura,
          data_intervento_taratura_aperto,
          data_richiesta_periodica,
          data_scadenza_periodica,
          data_scadenza_periodica_da_db_precedente,
          data_scadenza_taratura,
          data_scadenza_taratura_da_db_precedente,
          ultimo_intevento_periodica,
          ultimo_intevento_taratura,

          ...rest
        } = bilancia

        setBilanciaDuplicate(rest as Bilancia)
      })
    }
  }, [filters.duplicate_from])

  return (
    <div className="page">
      <div className="row mt-4">
        <div className="col-12">
          <div className="d-flex align-items-center">
            <Link
              to="/bilance"
              className="p-sm no-link d-flex align-items-center"
            >
              <span className="material-icons text-secondary">scale</span>
              <span className="ms-2">Lista bilance</span>
            </Link>
            <span className="material-icons text-secondary">chevron_right</span>
            <span className="ms-2 p-sm">Crea bilancia</span>
          </div>
        </div>
        <div className="col-12 d-flex justify-content-between mt-2">
          <h1 className="title">Crea bilancia</h1>
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-md-12">
          <Card>
            <CardBody
              style={{
                backgroundColor: '#F8F9FA',
              }}
            >
              <div className="row">
                <div className="col-md-8">
                  <Formik
                    initialValues={
                      bilanciaDuplicate
                        ? {
                            ...bilanciaDuplicate,
                            id: undefined,
                            matricola: '',
                          }
                        : (initialValues as any)
                    }
                    onSubmit={saveBilancia}
                    validationSchema={schema}
                    enableReinitialize
                  >
                    {({ handleSubmit, isSubmitting }) => (
                      <form>
                        <FormBilancia />
                        <div className="d-flex justify-content-end">
                          <Button
                            onClick={() => handleSubmit()}
                            variant="secondary text-white"
                            disabled={isSubmitting}
                          >
                            Salva
                          </Button>
                        </div>
                      </form>
                    )}
                  </Formik>
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  )
}
